import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element;
        this.element[this.identifier] = this;
    }

    selectPostcode() {
        var w = window.open("/postcodes/select.html", "pcselect", "left=600,screenX=600,top=80,screenY=100,menubar=no,toolbar=no,width=400,height=600,resizable=yes", false);
        w.focus();
        // remember which window we created
        window.pc_popup = w;
    }

    postcodeSelected( { detail } ) {
        this.log('postcodeSelected', [detail]);
        this.form.postcode.value = detail.postcode;
        this.form.gemeente.value = detail.naam;
        window.pc_popup.close();
    }

    disconnect() {
        this.element[this.identifier] = null;
        super.disconnect();
    }
}
